import React from 'react';
import cx from 'classnames';
import isEqual from 'date-fns/is_equal';
import { objectOf, string, bool, element } from 'prop-types';

import styles from './styles.scss';
import { dateToString } from '../../../helpers/formatData';
import './../_variables.scss'

export default class CalendarInfo extends React.PureComponent {

    static propTypes = {
        connectionData: objectOf(string),
        connectionIcon: element,
        useWatchlistsAsAdSource: bool
    };

    calculateDateDisplay = (date) => {
        if (date === 'N/A') { return 'N/A';}
        const dateDisplay = dateToString(date);
        const currentDate = dateToString(new Date());
        if (isEqual(dateDisplay, currentDate)) { return 'Today';}
        return dateDisplay;
    }

    render() {
        const { connectionData, connectionIcon, useWatchlistsAsAdSource } = this.props;
        const listData = [
            {
                name: 'Spot Data',
                className: 'spotData'
            },
            {
                name: 'Live Reads',
                className: 'liveRead'
            }
        ];

        useWatchlistsAsAdSource && listData.push({ name: 'Watchlist', className: 'watchlist' });

        const gaStartDate = this.calculateDateDisplay(connectionData.startDate);
        const gaEndDate = this.calculateDateDisplay(connectionData.endDate);

        return (
            <div className={styles["container"]}>
                <div className={styles["content-row"]}>
                    <div className={styles.contentDetail}>
                        {connectionIcon}
                        <span>{connectionData.name}</span>
                    </div>
                    <div>
                        {gaStartDate} - {gaEndDate}
                    </div>
                </div>
                <div className={styles["content-row"]}>
                    {
                        listData.map(data => (
                            <div key={data.className} style={{display: "flex"}}>
                                <div
                                    className={cx(styles.legend, styles[data.className])}
                                />
                                <span>{data.name}</span>
                            </div>
                        ))
                    }
                </div>
            </div>
        );
    }
}
